module.exports = __webpack_public_path__ + "static/media/hw_ko_10.28f019f7.flv";